module.exports = __webpack_public_path__ + "6f0a76321d30f3c8120915e57f7bd77e.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/theme-chalk/fonts/element-icons.ttf
// module id = 227
// module chunks = 1